import apiCall from "./apiCall";

const ajaxConfig = {

  async fetchRoles() {
    return await apiCall("platform/webclient/role_list", []);
  },

  async fetchUsers() {
    return await apiCall("user/user/list_users", []);
  },

   async inviteUser(data) {
    let response = await apiCall("user/user/invite_user", data);
    return response;
  },

  async changeUserRole(data) {
    let response = await apiCall("user/user/change_role", data);
    return response;
  },
  
  async deleteUser(data) {
    let response = await apiCall("user/user/remove_user", data);
    return response;
  },

  async createWifiPlan(data) {
    let response = await apiCall("platform/webclient/new_wifi_plan", data);
    return response;
  },

  async fetchWifiPlans(data) {
    return await apiCall("platform/webclient/wifi_plans", data);
  },

  async updateWifiPlan(data) {
    return await apiCall("platform/webclient/update_wifi_pan", data);
  },
  async createRouter(data) {
    let response = await apiCall("platform/webclient/new_router", data);
    return response;
  },
  async fetchRouters(data) {
    return await apiCall("platform/webclient/routers", data);
  },
  async updateRouter(data) {
    return await apiCall("platform/webclient/update_router", data);
  },

  async getWallet(data) {
    return await apiCall("platform/webclient/get_wallet", data);
  },
  async createWallet(data) {
    return await apiCall("platform/webclient/create_wallet", data);
  },

  async pingWallet(data) {
    return await apiCall("platform/webclient/ping_wallet", data);
  },

  async readSettings(data) {
    return await apiCall("platform/webclient/read_settings", data);
  },

  async fetchPortalPlans(data) {
    return await apiCall("platform/webclient/portal_plans", data);
  },

  async fetchLicenseInfo(data) {
    return await apiCall("central/licenseinvoice/dashboard_payload", data);
  },
  async payLicense(data) {
    return await apiCall("central/licenseinvoice/process_license_payment", data);
  },
  async changeLicensePlan(data) {
    return await apiCall("central/licenseinvoice/change_license_plan", data);
  }

};

export default ajaxConfig;